import { render, staticRenderFns } from "./ScrollMagicScene.vue?vue&type=template&id=67c660cb&"
import script from "./ScrollMagicScene.vue?vue&type=script&lang=ts&"
export * from "./ScrollMagicScene.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports